import { DateUtils } from 'react-day-picker';

const isDayBefore = (day1: Date, day2: Date) =>
  DateUtils.isDayBefore(day1, day2);

export default isDayBefore;
